<template>
  <q-layout view="lHh Lpr lFf">
    <q-header :class="{ 'safe-area-header': needInset.android }">
      <q-toolbar>
        <q-toolbar-title class="text-center q-pl-md">
          <span class="sw-title">{{ category.name }}</span>
        </q-toolbar-title>
        <q-btn
          class="absolute-left"
          flat
          icon="arrow_back_ios"
          @click="$router.go(-1)"
        />
      </q-toolbar>
    </q-header>

    <q-page-container>
      <sync-required></sync-required>
      <router-view />
    </q-page-container>
    <q-footer :class="{ 'safe-area-footer': needInset.all }">
    </q-footer>
  </q-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import SyncRequired from 'src/components/SyncRequired'

export default {
  components: { SyncRequired },
  name: 'Categories',
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      categories: 'company/categories',
      needInset: 'common/needInset'
    }),
    category() {
      let cat = this.categories.find(
        (category) => category.id === Math.trunc(this.$route.params.id)
      )
      if (cat === undefined) {
        this.categories.every((category) => {
          cat = category.childs.find(
            (category) => category.id === Math.trunc(this.$route.params.id)
          )
          return cat === undefined
        })
      }
      return cat
    }
  },
}
</script>
